export default {
  qualificationsData(state) {
    return state.list.data
  }
}
